/* eslint-disable */
import Helpers from '@helpers';

$(document).ready(function () {
    $(".checkbox-td").click(function (e) {
        var radios = $(this).closest("div").find("input:radio");
        radios.prop("checked", false);
        $(this).find('input:radio:first').prop("checked", true).change();
    });
});
